const urls = {
	boardURL: process.env.REACT_APP_BOARD_URL,
	socketEndpoint: process.env.REACT_APP_SOCKET_URL,
	backendURL: process.env.REACT_APP_BACKEND_URL
}

export default urls;